import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import {
  Feasibility,
  FlexibilityPrices,
  Survey,
  SurveyLocationUploadResult,
  SurveyMetadataFormState,
  SurveyQualificationsFormState,
  SurveyQuotasFormState,
} from '@ps/survey-utils';
import { SurveyCreationPricingState } from '../survey-creation-state.model';

export const SurveyCreationActions = createActionGroup({
  source: 'Survey Creation',
  events: {
    Init: props<{ surveyId: Nullable<number> }>(),
    'Create Standard Survey': emptyProps(),
    'Update Metadata': props<{ metadata: SurveyMetadataFormState }>(),
    'Update Qualifications': props<{
      qualifications: SurveyQualificationsFormState;
    }>(),
    'Update Quotas': props<{ quotas: SurveyQuotasFormState }>(),
    'Save Survey': emptyProps(),
    'Upload Location Codes': props<{
      countryCode: string;
      surveyId: number;
      qualificationCode: number;
      qualificationName: string;
      file: File;
    }>(),
    'Clear Location Codes': props<{
      qualificationCode: number;
      qualificationName: string;
    }>(),
    'Download Location Codes Template': props<{
      countryCode: string;
      qualificationCode: number;
    }>(),
    'Download Validated Location File': props<{
      qualificationCode: number;
    }>(),
    Reset: emptyProps(),
  },
});

export const SurveyCreationApiActions = createActionGroup({
  source: 'Survey Creation API',
  events: {
    'Create Standard Survey Success': props<{ survey: Survey }>(),
    'Create Standard Survey Failure': props<{ error: string }>(),
    'Save Survey Success': props<{ survey: Survey }>(),
    'Save Survey Failure': props<{ error: string }>(),
    'Load Survey For Edit Success': props<{ survey: Survey }>(),
    'Load Survey For Edit Failure': props<{ error: string }>(),
    'Upload Location Codes Success': props<{
      qualificationCode: number;
      qualificationName: string;
      result: SurveyLocationUploadResult;
    }>(),
    'Upload Location Codes Failure': props<{
      qualificationCode: number;
      error: string;
    }>(),
  },
});

export const SurveyCreationNavbarActions = createActionGroup({
  source: 'Survey Creation Navbar',
  events: {
    'Toggle Manual Processing': props<{
      companyId: number;
      enabled: boolean;
    }>(),
    'Recalculate Feasibility': emptyProps(),
    'Apply Cpi Pricing': props<SurveyCreationPricingState>(),
  },
});

export const SurveyCreationNavbarApiActions = createActionGroup({
  source: 'Survey Creation Navbar API',
  events: {
    'Compute Score Pending': emptyProps(),
    'Compute Score Success': props<{
      score: number;
      scorePercentage: number;
    }>(),
    'Compute Score Failure': props<{ error: string }>(),
    'Recalculate Feasibility Pending': emptyProps(),
    'Recalculate Feasibility Success': props<Feasibility>(),
    'Recalculate Feasibility Failure': props<{ error: string }>(),
    'Load Flexibility Prices Success': props<{ prices: FlexibilityPrices }>(),
    'Load Flexibility Prices Failure': props<{ error: string }>(),
  },
});
